import isItemView from 'owa-mail-store/lib/utils/isItemView';
import MailSwipeAction from 'owa-service/lib/contract/MailSwipeAction';
import {
    archiveConversationAction,
    deleteConversationAction,
    toggleConversationFlagAction,
    toggleConversationPinAction,
    toggleConversationReadAction,
} from './conversationActions';
import {
    archiveItemAction,
    deleteItemAction,
    toggleItemFlagAction,
    toggleItemPinAction,
    toggleItemReadAction,
} from './itemActions';
import { MailListItemViewProps } from '../../components/TouchBehavior';

type TriageAction = (props: MailListItemViewProps) => void;

export const getSwipeAction = (swipeActionName: MailSwipeAction): TriageAction => {
    switch (swipeActionName) {
        case MailSwipeAction.None:
            return null;
        case MailSwipeAction.Delete:
            return performSwipeAction(deleteConversationAction, deleteItemAction);
        case MailSwipeAction.Archive:
            return performSwipeAction(archiveConversationAction, archiveItemAction);
        case MailSwipeAction.ToggleFlag:
            return performSwipeAction(toggleConversationFlagAction, toggleItemFlagAction);
        case MailSwipeAction.TogglePin:
            return performSwipeAction(toggleConversationPinAction, toggleItemPinAction);
        case MailSwipeAction.ToggleRead:
            return performSwipeAction(toggleConversationReadAction, toggleItemReadAction);
    }
};

const performSwipeAction = (conversationAction: TriageAction, itemAction: TriageAction) => (
    props: MailListItemViewProps
) => {
    isItemView() ? itemAction(props) : conversationAction(props);
};
